import { render, staticRenderFns } from "./ForbiddenAccess.vue?vue&type=template&id=3ec6eb66&"
import script from "./ForbiddenAccess.vue?vue&type=script&lang=js&"
export * from "./ForbiddenAccess.vue?vue&type=script&lang=js&"
import style0 from "./ForbiddenAccess.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
